import Vue from "vue";
import store from '@/store';
import VueRouter from "vue-router";

Vue.use(VueRouter);
export const routes = [
 { path: "/receipt-info", name: "ReceiptInfo", component: () => import("@/views/ReceiptInfo.vue"), meta: { showTab: false } },
    {path: "/", redirect: "/pool"},
    {
        path: "/pool",
        name: "Pool",
        component: () => import('@/views/Ticket-Pool'),
        meta: {
            showTab:true
        }
    },
    {
        path: "/wait",
        name: "Wait",
        component: () => import('@/views/WaitReport.vue'),
        meta: {
            showTab:true
        }
    },
    {
        path: "/ticket",
        name: "Ticket",
        component: () => import('@/views/Ticket'),
        meta: {
            showTab:false
        }
    },
    {
        path: "/login",
        name: "login",
        component: () => import('@/views/Login'),
        meta: {
            showTab:false
        }
    },
    {
        path: "/history",
        name: "history",
        component: () => import('@/views/History'),
        meta: {
            showTab:true
        }
    },
    {
        path: "/mine",
        name: "Mine",
        component: () => import('@/views/Mine'),
        meta: {
            showTab:true
        }
    },
    {
        path: "/order/detail",
        name: "OrderDetail",
        component: () => import('@/views/OrderDetail'),
        meta: {
            showTab:false
        }
    },
    {
        path: "/cinema/rule",
        name: "CinemaRule",
        component: () => import('@/views/RuleDetail'),
        meta: {
            showTab:false
        }
    },
    {
        path: "/rule",
        name: "Rule",
        component: () => import('@/views/Rule'),
        meta: {
            showTab:true
        }
    },
    {
        path: "/withdraw",
        name: "Withdraw",
        component: () => import('@/views/Withdraw'),
        meta: {
            showTab:false
        }
    },
    {
        path: "/withdraw-records",
        name: "WithdrawRecords",
        component: () => import('@/views/WithdrawRecords'),
        meta: {
            showTab:false
        }
    },
    {
        path: "/bid-notify-settings",
        name: "BidNotifySettings",
        component: () => import('@/views/BidNotifySettings'),
        meta: {
            showTab: false
        }
    },
    {
        path: "/new-order-notify",
        name: "NewOrderNotify",
        component: () => import('@/views/NewOrderNotify'),
        meta: {
            showTab: false
        }
    },
    {
        path: "/new-order-notify/rule",
        name: "NewOrderNotifyRuleAdd",
        component: () => import('@/views/NewOrderNotifyRule'),
        meta: {
            showTab: false
        }
    },
    {
        path: "/new-order-notify/rule/:id",
        name: "NewOrderNotifyRuleEdit",
        component: () => import('@/views/NewOrderNotifyRule'),
        meta: {
            showTab: false
        }
    },
    {
        path: "/cinema-class",
        name: "CinemaClass",
        component: () => import('@/views/CinemaClass'),
        meta: {
            showTab: false
        }
    },
    {
        path: "/cinema-class/new",
        name: "CinemaClassNew",
        component: () => import('@/views/CinemaClassDetail'),
        meta: {
            showTab: false
        }
    },
    {
        path: "/cinema-class/:id",
        name: "CinemaClassDetail",
        component: () => import('@/views/CinemaClassDetail'),
        meta: {
            showTab: false
        }
    },
    {
        path: "/pc-login",
        name: "PCLogin",
        component: () => import('@/views/PCLogin'),
        meta: {
            showTab:false
        }
    },
    {
        path: "/rule/line",
        name: "RuleLine",
        component: () => import('@/views/RuleLine'),
        meta: {
            showTab:false
        }
    },
    {
        path: "/rule/custom",
        name: "RuleCustom",
        component: () => import('@/views/RuleCustom'),
        meta: {
            showTab:false
        }
    },
    {
        path: "/404",
        name: "404",
        component: () => import('@/views/404'),
        meta: {
            showTab:false
        }
    },
    {
        path: "/points",
        name: "Points",
        component: () => import('@/views/points/index.vue'),
        meta: {
            title: '我的积分',
            requireAuth: true
        }
    },
    {
        path: "/points/log",
        name: "PointsLog",
        component: () => import('@/views/points/PointsLog.vue'),
        meta: {
            title: '积分明细',
            requireAuth: true
        }
    },
    {
        path: "/member",
        name: "Member",
        component: () => import('@/views/member/index.vue'),
        meta: {
            title: '会员中心',
            requireAuth: true
        }
    },
    {
        path: "/wait-bid",
        name: "WaitBid",
        component: () => import('@/views/WaitBid.vue'),
        meta: {
            showTab:true
        }
    },
    {
        path: "/bid-order/:orderId",
        name: "BidOrderDetail",
        component: () => import('@/views/bidOrderDetail.vue'),
        meta: {
            showTab: false
        }
    },
    {
        path: "/bid-records",
        name: "BidRecords",
        component: () => import('@/views/BidRecords.vue'),
        meta: {
            showTab: false
        }
    },
    {
        path: "/confirm-order",
        name: "ConfirmOrder",
        component: () => import('@/views/ConfirmOrder.vue'),
        meta: {
            showTab: false
        }
    },
    {
        path: "/upload-ticket-code",
        name: "UploadTicketCode",
        component: () => import('@/views/UploadTicketCode.vue'),
        meta: {
            showTab: false
        }
    },
    {
        path: "*",
        redirect: ()=>{
            return '404'
        },
        meta: {
            showTab:false
        }
    },
];

const createRouter = () => new VueRouter({
    mode: 'history', // require service support
    scrollBehavior: () => ({ y: 0 }),
    routes: routes
})

const router = createRouter()


// router.beforeEach((to, from, next) => {
//     // next();return;
//     console.log('beforeEach....')
//     if (to.meta.requireAuth && !store.getters.authCode) {
//         Toast('请先登录');
//         next({
//             path: '/login',
//             query: {
//                 redirect: to.fullPath
//             }
//         });
//     } else if (to.name != 'login' && to.name.indexOf('error') == -1 && store.getters.authCode) {
//         if (store.getters.hasGetMemberInfo) {
//             next();
//         } else {
//             store.dispatch('getBaseData');
//             store.dispatch('getMemberInfo').then(() => {
//                 next();
//             }).catch(() => {
//                 next();
//             })
//         }
//     } else {
//         next();
//     }
// });

export function resetRouter() {
    const newRouter = createRouter()
    router.matcher = newRouter.matcher // reset router
}

export default router;
